import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'

export function darkenColor(color: string): string {
  const hex = color.replace('#', '')
  const r = Math.max(0, Math.floor(Number.parseInt(hex.slice(0, 2), 16) * 0.8))
  const g = Math.max(0, Math.floor(Number.parseInt(hex.slice(2, 4), 16) * 0.8))
  const b = Math.max(0, Math.floor(Number.parseInt(hex.slice(4, 6), 16) * 0.8))
  return `rgb(${r}, ${g}, ${b})`
}

const colorsPallette = [
  '#A451E6', // purple
  '#75D78E', // light green
  '#E91E63', // magenta
  '#FF895D', // orange
  '#F7C52D', // yellow
  '#FC8787', // coral/pink
  '#908E9E', // gray
  '#4A90E2', // blue
  '#24C84E', // bright green
  '#1ABC9C', // teal
  '#E74C3C', // red
  '#FF9800', // amber
  '#E67E22', // darker orange
  '#3498DB', // lighter blue
  '#795548', // brown
  '#607D8B', // blue gray
]

export function getPalletteColor(itemIndex: number): string {
  return colorsPallette[itemIndex % colorsPallette.length]!
}

export function formatChartValue(value: NormalizedNumber, underlyingToken: Token): string {
  if (underlyingToken.symbol === 'ETH' || underlyingToken.symbol === 'WETH') {
    return `${underlyingToken.format(value, { style: 'compact' })} ETH`
  }
  return underlyingToken.formatUSD(value, { compact: true })
}

export function formatPieChartValue(value: NormalizedNumber): string {
  return Intl.NumberFormat('en-US', {
    maximumFractionDigits: value.gt(10_000) ? 0 : value.gt(1) ? 2 : 6,
  }).format(value.toNumber())
}
